export default /* glsl */`
    particlePos = (matrix_model * vec4(particlePos, 1.0)).xyz;
`;
